export default "__VITE_ASSET__JYViWahA__"